import React from "react";
import { Typography } from "@mui/material";

export const RenderNotes = (value, nameClass, isNotes) => {
  let string = '';
  (isNotes) ? string = 'Notes:' :  string = '';
  if (!value){
    return (<></>);
  }
  value.split("\n").forEach(item => {
    item.split(" ").forEach(element=> element === '' ?  string+='&nbsp' : string+=`&nbsp${element}`);
      string += '<br />';
  });
  return (
    <Typography variant="subtitle1" className={nameClass} >
      <div dangerouslySetInnerHTML={{ __html: string }} />
    </Typography>
  );
};